import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-disable-two-factor',
  templateUrl: './disable-two-factor.component.html',
})
export class DisableTwoFactorComponent {
  @Input() team_member: any;

  current_password = '';
  saving = false;
  confirmed = false;
  show_current = false;

  constructor(
    private modalController: ModalController,
    private apiService: ApiService,
    public globalService: GlobalService
  ) {}

  get canSubmit(): boolean {
    return !this.saving && !!this.current_password;
  }

  async Submit() {
    if (!this.canSubmit) return;
    this.saving = true;
    try {
      const data: any = await this.apiService.put(
        `team_members/${this.team_member.guid}/two_factor/disable`,
        { current_password: this.current_password }
      );
      if (!data.success) {
        this.globalService.presentToastMessage(data.message || 'Failed to disable two-factor authentication.', false);
        return;
      }
      this.confirmed = true;
    } catch {
      this.globalService.presentToastMessage('Failed to disable two-factor authentication.', false);
    } finally {
      this.saving = false;
    }
  }

  async Close() {
    this.modalController.dismiss(this.confirmed);
  }
}
